import { Pipe, PipeTransform } from '@angular/core';
import { KeysOfType } from '@zaoblako/web/core/types/keys-of.type';

@Pipe({
  standalone: true,
  name: 'sum'
})
export class SumPipe implements PipeTransform {
  public transform<T>(array: T[], key: KeysOfType<T, number>, withRate: boolean = false): number {
    if (!Array.isArray(array)) {
      return 0;
    }
    return array.reduce((sum, item) => sum + +item[key] * (withRate ? +item['rate'] : 1), 0);
  }
}
